<template>
  <form :id="formId" style='width: 100%' @submit.prevent='handleSubmit'>
    <div class="login-form">
      <InputText
        email
        label="Correo electrónico"
        autocomplete="email"
        placeholder="Ingresa tu correo electrónico."
        v-model="email"
        missingErrorMessage="Ingresa tu correo electrónico."
        :showEmptyInputError="tryToSubmit && !email"
      />
      <InputText
        password
        label="Contraseña"
        placeholder="Ingresa tu contraseña"
        v-model="password"
        missingErrorMessage="Ingresa tu contraseña."
        :showEmptyInputError="tryToSubmit && !password"
      />
      <p
        class='text-m-bold'
        style='text-decoration: underline; cursor: pointer;'
        @click='redirectForgotPassword'
      >
        ¿Olvidaste tu contraseña?
      </p>
    </div>
    <div style='padding-top: 32px'>
      <ButtonDefinitive
        label="Iniciar sesión"
        buttonType='submit'
      />
      <div id="recaptcha-container2"></div>
    </div>
  </form>
</template>

<script>
import { api2 } from "../../services/api";
import InputText from '../Form/InputText.vue'
import ButtonDefinitive from "../Button/ButtonDefinitive.vue"
import utils from '../../commons/mixins/utils'

export default {
  name: "LoginForm",
  components: {
    InputText,
    ButtonDefinitive,
  },
  props: {
    formId: String,
  },
  data() {
    return {
      email: "",
      password: "",
      tryToSubmit: false,
      siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      widgetId: null
    };
  },
  mounted() {
    if (this.widgetId == null) {
      setTimeout(()=>{
          if (!window.grecaptcha) {
            console.error("reCAPTCHA no cargado");
            return;
          }

          this.widgetId = window.grecaptcha.render('recaptcha-container2', {
              'sitekey' : this.siteKey,
              'size': 'invisible',
              'callback' : this.onVerify
          });
          // alert("addEventListener")
          // this.initRecaptcha();
      }, 1000)
    }
  },
  methods: {
    onVerify(token) {
      this.processLogin(token)
    },
    handleSubmit() {
      this.trackEvent('click_login_with_email_btn', 'login')
      this.tryToSubmit = true
      if (!this.email || !this.password) {
        this.trackEvent('click_login_with_email_failed_empty_inputs', 'login') 
        return
      }

      if (!utils.methods.validateEmail(this.email)){
        this.trackEvent('click_login_with_email_failed_invalid_email', 'login') 
        return
      } 
      grecaptcha.execute();
    },
    redirectForgotPassword() {
      this.$router.push('/forgotPassword')
    },
    processLogin(token) {
      this.showLoading()
      const payload = {
        email: this.email,
        password: this.password,
        recaptcha: token
      }
      //api2.post(`auth/clients`, payload)
      api2.post(`auth/clients`, payload, { withCredentials: true })
        .then(response => {
          console.log(response)
          if (response.status !== 200) throw new Error()
          localStorage.setItem("token", response.data?.data?.token)
          //this.$store.commit('SET_USER', response.data.result)
          this.$store.commit('SET_USER', response.data.data)
          this.$swal.close()

          this.trackEvent('login_with_email_success', 'login')

          window.location.href = process.env.VUE_APP_WEBURL
        })
        .catch(e => {
          console.log({ e })
          this.showError('Revise sus datos e intente nuevamente.')
          this.trackEvent('login_with_email_failed', 'login')
          grecaptcha.reset();
        })
    }
  },
};
</script>
<style lang="scss" scoped>
.login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}
</style>